// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-signatory .form-radio-button{padding:0 30px}`, "",{"version":3,"sources":["webpack://./src/components/signature/Documents.scss"],"names":[],"mappings":"AACI,qCACI,cAAA","sourcesContent":[".select-signatory {\n    .form-radio-button {\n        padding: 0 30px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
